import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Loading, Modal } from '../../components/all';
import useUserStore from '../../store/useUserStore';
import RenderAula from '../../components/renderAula.js';
import { parse, subDays } from "date-fns";
import toast from '../../utils/toast';

import useAula from '../../hooks/useAula.js';

export default function HomeView() {
  const { usuario } = useUserStore();

  const [loadingTotal, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();

  const { SearchAulas, loading: loadingAulas, error, DeleteAula, RenderTotalAulas, aulas } = useAula();

  const loading = loadingAulas || loadingTotal && true;

  useEffect(() => {
    const verificarSenha = () => {
      if (usuario.senha === '123456') {
        setModalMessage(
          <div className="flex flex-col items-center gap-4 text-center">
            <img alt='imageModal' className='w-40 mx-auto' src={'undraw_notify_rnwe.svg'} />
            <div>
              <h2 className="font-semibold text-lg text-gray-800 mb-1">Senha fraca detectada</h2>
              <p className="text-sm text-gray-600">
                Sua senha ainda é a padrão <strong>(123456)</strong>. Recomendamos mudar agora para aumentar sua segurança.
              </p>
            </div>
            <Button back={'#4B003B'} onClick={() => setModalMessage('')} cor="#FFF">
              Entendi
            </Button>
          </div>
        )
        return;
      }
    };
    verificarSenha();
  }, [])

  const alterPage = (page) => {
    setLoading(true);
    try {
      if (usuario.atividade) {
        navigate(`/${page}`);
      } else {
        setModalMessage(
          <div className="text-center flex flex-col gap-3">
            <h2 className="font-semibold text-lg text-gray-800">Conta bloqueada</h2>
            <p className="text-sm text-gray-600">
              Sua conta está bloqueada. Entre em contato com nosso atendimento que resolvemos isso rapidinho.
            </p>
            <Button back={'#4B003B'} onClick={() => setModalMessage('')} cor="#FFF">
              Fechar
            </Button>
          </div>
        );
      }
    } catch (error) {
      toast.error(`Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchAulas = useCallback(async () => {
    await SearchAulas(usuario.usuario_id);
  }, [usuario.usuario_id]);

  useEffect(() => {
    if (usuario) {
      fetchAulas();
    }
  }, [usuario, fetchAulas]);

  const handleAction = async (acao, item) => {
    //console.log('Ação:', acao, 'Item:', item);
    if (acao === "Excluir") {
      setModalMessage(
        <div className="text-center flex flex-col gap-4">
          <p className='text-gray-700'>
            Deseja excluir a aula do dia <strong>{item?.data}</strong>?
          </p>
          <div className="flex gap-3 justify-center">
            <Button type={4} onClick={() => confirmAction(item)}>
              Sim <span className="material-icons">check</span>
            </Button>
            <Button type={3} onClick={() => setModalMessage('')}>
              Não <span className="material-icons">close</span>
            </Button>
          </div>
        </div>
      )
      await fetchAulas();
    }
  }

  const confirmAction = async (item) => {
    const horaPraPoderExcluir = usuario.configuracoes.horasPraDesmarcarAulas;

    //console.log('item:', item);
    //console.log('horaPraPoderExcluir:', horaPraPoderExcluir);
    if (!item || !horaPraPoderExcluir) {
      toast.error('Erro ao excluir aula!')
      fetchAulas();
      setModalMessage('');
      return;
    }

    let res = await DeleteAula(item, horaPraPoderExcluir);
    if (res) {
      fetchAulas();
      setModalMessage('');
    }
  };

  const renderAulaItem = (item) => (
    <RenderAula item={item} key={item.aula_id} tipo={2} handleAction={handleAction} />
  );

  const aulasFuturas = (aulas || []).filter(
    (item) => parse(item.data, "dd/MM/yyyy", new Date()) >= subDays(new Date(), 1)
  );

  localStorage.setItem('aulasFuturas', JSON.stringify(aulasFuturas));

  return (
    <div className='min-h-full flex flex-col items-center p-4 gap-4 overflow-y-auto pb-24'>

      {/* Header */}
      <div className='w-full max-w-4xl  rounded-2xl shadow-sm p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-20'>
        <div>
          <h1 className='font-bold text-2xl text-gray-800 capitalize'>
            Bem-vindo, {usuario.nome || 'aluno'} 👋
          </h1>
          <p className="text-sm text-gray-500">Gerencie suas aulas de forma rápida e simples</p>
        </div>
      </div>

      {/* Resumo */}
      <div className='flex flex-col w-full gap-2'>
        <RenderTotalAulas categorias={(usuario.categoria_pretendida).split("")} />
        <Button onClick={() => alterPage('selecionarTipo')}>
          Marcar Aula
          <span className="material-icons">add</span>
        </Button>
      </div>


      {/* Lista de aulas */}
      <div className='w-full max-w-4xl rounded-2xl shadow-sm py-4 flex flex-col gap-3 max-h-full overflow-y-auto'>
        <div className="flex items-center justify-between">
          <h2 className='text-lg font-semibold text-gray-800'>Aulas agendadas</h2>
          <span className="text-xs text-gray-500">
            {aulasFuturas.length} futura{aulasFuturas.length !== 1 && 's'}
          </span>
        </div>

        <div className='w-full overflow-y-auto rounded-xl border border-gray-200 max-h-full'>
          {loading && <Loading />}

          {!loading && (error || aulasFuturas.length === 0) ? (
            <div className='p-6 text-center'>
              <p className='text-sm text-gray-500'>
                {error ? `Erro: ${error}` : 'Nenhuma aula agendada ainda'}
              </p>
            </div>
          ) : (
            <div className="flex flex-col p-3 gap-2">
              {aulasFuturas.map(renderAulaItem)}
            </div>
          )}
        </div>

        {aulasFuturas?.length > 2 &&
          <p className='flex gap-2 text-xs text-gray-500 items-center justify-center pt-1'>
            Arraste para ver mais aulas
            <span className="material-icons text-sm">swipe_down</span>
          </p>
        }
      </div>


      <Loading visible={loading} />

      <Modal isOpen={modalMessage}>
        {modalMessage}
      </Modal>
    </div>
  );
};
